import { Container, Grid, Typography, Card, CardContent, CardMedia, Box } from '@mui/material';
import { getImageUrl } from '../../utils';

 

const coachesData = [
  {
    name: 'Sandra Möller',
    description: 'Smärtfri & stark genom Pilates – nu hjälper jag dig dit!',
    image: getImageUrl('coach-sandra2.png'),
  },
  {
    name: 'Agnes Knutsson',
    description: 'Från rehabilitation till passion – jag tränar kropp och sinne.',
    image: getImageUrl('coach-agnes2.png'),
  },
  {
    name: 'Johanna Magnelin',
    description: 'Din träningskompis! Jag hejar på dig hela vägen.',
    image: getImageUrl('coach-johanna3.png'),
  },
  {
    name: 'Malin Heimdahl',
    description: 'Skratt, balans & energi – träning ska vara kul!',
    image: getImageUrl('coach-malin2.png'),
  },
  {
    name: 'Jennie Levin',
    description: 'Morgonboost och variation – vi gör det roligt!',
    image: getImageUrl('coach-jennie2.png'),
  },
];

const Coaches = () => (
  <Box sx={{ background: 'linear-gradient(to bottom, #ffffff, #fdfdfd)', py: { xs: 6, md: 8 } }}>
    <Container maxWidth="lg">
      <Typography
        variant="h3"
        align="center"
        sx={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 700,
          color: '#222',
          fontSize: { xs: '2rem', md: '2.5rem' },
          mb: 2,
        }}
      >
        Våra instruktörer
      </Typography>
      <Typography
        variant="body1"
        align="center"
        sx={{
          maxWidth: '700px',
          mx: 'auto',
          fontSize: '1.1rem',
          color: '#444',
          mb: 6,
        }}
      >
        Passionerade, certifierade och alltid redo att lyfta dig – lär känna teamet bakom varje energifyllt pass!
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {coachesData.map((coach, index) => (
          <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
            <Card
              sx={{
                background: 'rgba(255,255,255,0.6)',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                borderRadius: '1rem',
                transition: 'all 0.3s ease',
                textAlign: 'center',
                overflow: 'hidden',
                '&:hover': {
                  transform: 'translateY(-6px)',
                  boxShadow: '0 12px 30px rgba(0, 0, 0, 0.15)',
                },
              }}
            >
              <Box sx={{ position: 'relative', height: 0, paddingTop: '100%' }}>
                <CardMedia
                  component="img"
                  image={coach.image}
                  alt={coach.name}
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    filter: 'grayscale(100%)',
                    transition: 'filter 0.3s ease',
                    '&:hover': {
                      filter: 'grayscale(0%)',
                    },
                  }}
                />
              </Box>
              <CardContent sx={{ px: 3, py: 2 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontFamily: 'var(--font-heading)',
                    fontWeight: 700,
                    color: '222',
                    mb: 1,
                  }}
                >
                  {coach.name}
                </Typography>
                
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default Coaches;
